import React from 'react';
import ruleEditor from '../../layouts/RuleEditor.json';
import ruleEditorRule from '../../schema/RuleEditor.json';
import ModalBox from './ModalBox';
import { Rule } from './utils/Validation';
import { ValidationProvider } from '../ValidationProvider';
import { DropdownControl } from './controls/DropdownControl';
import { firstElement, get } from './utils/Utils';
import { useFormData } from '../FormDataProvider';

// Define ControlEditorProps interface
interface ControlEditorProps {
    ruleToEdit: Rule;
    data: any;
    dataKey: string | undefined;
    onComplete?: () => void; // Callback for completion
    onError?: () => void;     // Callback for error
    onClose?: () => void;     // Callback for close
}

export const getDefaultRule = (type: string): Rule | undefined => {
    if (type === "text") {
        return {
            type: "string"
        } as Rule
    } else if (type === "textarea") {
        return {
            type: "string"
        } as Rule
    } else if (type === "select") {
        return {
            type: "string"
        } as Rule
    } else if (type === "date") {
        return {
            type: "string"
        } as Rule
    } else if (type === "check") {
        return {
            type: "boolean"
        } as Rule
    } else {
        throw new Error(`Unsupported control type: ${type}`);
    }
}

const RuleEditor: React.FC<ControlEditorProps> = ({ ruleToEdit, data, dataKey, onComplete, onError, onClose }) => {
    const { formData } = useFormData();
    
    const handleComplete = () => {
        if (onComplete) onComplete();
    };

    const handleError = () => {
        if (onError) onError();
    };

    const handleClose = () => {
        if (onClose) onClose();
    };

    // prepare dropdowns
    var dataContextKeys = dataKey ? get(formData, `${dataKey}_Columns`, Object.keys(firstElement(data)).map(key => [key, key])) : Object.keys(firstElement(data)).map(key => [key, key]);
    var lessThan = ruleEditor.controls[3].controls[1] as DropdownControl;
    lessThan.items = dataContextKeys;
    var greaterThan = ruleEditor.controls[3].controls[4] as DropdownControl;
    greaterThan.items = dataContextKeys;
    var equalTo = ruleEditor.controls[3].controls[7] as DropdownControl;
    equalTo.items = dataContextKeys;

    return (
        <>
            <ValidationProvider rule={ruleEditorRule}>
                <ModalBox
                    action= {{
                        type: 'messagebox',
                        payload: {
                            title: 'Edit Validation',
                            layout: ruleEditor,
                            okbutton: true
                        }
                    }}
                    data={ruleToEdit}
                    onDataChange={() => { }}
                    mode="edit"
                    onComplete={handleComplete}
                    onError={handleError}
                    onClose={handleClose}
                    sx={{ minWidth: '300px' }}
                />
            </ValidationProvider>
        </>
    );
};

export default RuleEditor;